"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
// be sure to updated expectedFiles in valley-bank-utils when adding input files
// specifically for "isValleyFile" typeguard
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    vanCust: zod_1.z.string(),
    vanCustAcctRel: zod_1.z.string(),
    vanDepAcct: zod_1.z.string(),
    loanCustRel: zod_1.z.string(),
    cuoDeposit: zod_1.z.string(),
    collatCustRel: zod_1.z.string(),
    cuoCollat: zod_1.z.string(),
    psPlusPortfolio: zod_1.z.string(),
    psPlusAccount: zod_1.z.string(),
    psPlusSecDetail: zod_1.z.string(),
    psPlusSecMaster: zod_1.z.string(),
    vanCmmt: zod_1.z.string(),
    vanLoanAcct: zod_1.z.string(),
    vanProduct: zod_1.z.string(),
    vanList: zod_1.z.string(),
    cuoMaint: zod_1.z.string(),
    cuoLoan: zod_1.z.string(),
    bloombergMutualFund: zod_1.z.string(),
    derivativePath: zod_1.z.string().optional(),
});
exports.nodeType = 'file_valley_bank_ingest';
// every tape node must also export IntermediateRecordConfig.
// this type describes the configuration for the IntermediateRecord
// (type generated by converting UI Tape + Operation Node config ).
// this includes the config for the preceding operation + config for the Tape
// + any synthetic/generated config that is needed for the corresponding task.
// - any fields that are not part of config but are part of top level record.
exports.IntermediateRecordConfigSchema = exports.UIConfigSchema.omit({
    artifactSlug: true,
});
// every tape node must also export IntermediateRecord.
// it describes the record that will be inserted into the database. (well not completely,
// because it may be modified by synthetic node creation later)
// it includes IntermediateRecordConfig + top level field like type, externalFilename, loanProductSlug, creditFacilitySlug etc.
exports.artifactType = 'valleyBankIngest';
//# sourceMappingURL=types.js.map